import React from 'react';
import { Alert } from 'antd';

export const RBHBanner = (props: any) => {
  return (
    <Alert {...props} />
  );
};

export default RBHBanner;
